import { render, staticRenderFns } from "./CertificationPenaltyDialog.vue?vue&type=template&id=6110d562&"
import script from "./CertificationPenaltyDialog.vue?vue&type=script&lang=js&"
export * from "./CertificationPenaltyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports